/**
 * define all contants here
 */

const PlanType = {
    AIPLAN : 'AI_PLAN', // AI plan
    SHEETPLAN: 'SHEET_PLAN', // cureted plan
    ELITE_PLAN: 'ELITE_PLAN' // elite plan
}

const PlanName = {
    AI_PLAN: 'one_month_ai_diet_plan_autopay_subscription',
    SHEET_PLAN: 'one_month_smart_paid_diet_plan',
    ELITE_PLAN: 'one_month_elite_plan_subscription',
    YEARLY_ELITE_PLAN: 'one_year_elite_plan_subscription',
}

const ProductType = {
    AI_DIET_PLAN: "ai_diet_plan",
    PRO_ELITE_PLAN: "pro_lite_plan",
    YEARLY_AI_DIET_PLAN: "one_time_yearly_ai_plan",
    YEARLY_PRO_ELITE_PLAN: "one_time_yearly_pro_lite_plan"
}

export {
    PlanType,
    PlanName,
    ProductType
}